import './styles/landingLayout.css'

/**
 * Component representing the landing layout of the application.
 * @returns {JSX.Element} The LandingLayout component.
 */
export default function LandingLayout({fadeOut}) {
    return (
        <div className="spacer">
            <div className={`landingLayout flx-col${fadeOut ? " fade-out" : ""}`}>
                <h1 className="title">
                    <span>Développeur web</span><span>Front-End</span>
                </h1>
                <div className="description">J'adore donner vie à des idées sur le web, et je le fais avec style. Explorez mon travail et découvrez comment je peux apporter une touche de créativité à vos projets.</div>
            </div>
        </div>
    );
};